export function isGuestDisplayName(displayName) {
    return /^guest_/i.test(displayName.trim());
}
/** Friendly guest label by member order in the lobby/session roster. */
export function guestDisplayLabel(members, userId) {
    const guests = members.filter((m) => isGuestDisplayName(m.displayName));
    const idx = guests.findIndex((m) => m.userId === userId);
    return `Guest #${idx >= 0 ? idx + 1 : guests.length + 1}`;
}
/** Label for lobby cards and inputs; guests on default usernames become Guest #n. */
export function lobbyMemberDisplayLabel(member, allMembers) {
    if (!isGuestDisplayName(member.displayName)) {
        return member.displayName.trim() || "Detective";
    }
    return guestDisplayLabel(allMembers, member.userId);
}
/** In-world overhead label; same guest numbering as lobbyMemberDisplayLabel. */
export function worldLabelForPlayer(player, allPlayers) {
    return lobbyMemberDisplayLabel(player, allPlayers);
}
/** Default lobby name for a new guest member (before optional custom edit). */
export function defaultGuestLobbyDisplayName(existingMembers, newUserId) {
    const withNew = [
        ...existingMembers,
        { userId: newUserId, displayName: "guest_placeholder" },
    ];
    return guestDisplayLabel(withNew, newUserId);
}
